import { NgModule } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { TableModule } from '@openng/optimus-ui/table';
import { FlairrSummaryRoutingModule } from './flairr-summary-routing.module';
import { FlairrSummaryComponent } from './flairr-summary.component';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '@shared';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  imports: [
    BaseChartDirective,
    FontAwesomeModule,
    CommonModule,
    FlairrSummaryRoutingModule,
    TableModule,
    BrowserModule,
    SharedModule,
    BsDropdownModule,
  ],
  declarations: [FlairrSummaryComponent],
})
export class FlairrSummaryModule {}
